import React from "react";
import { Helmet } from "react-helmet";
import langsObj from "../resources/languageNames";
import routeNamesBr from "../resources/br/routeNames";
import routeNamesEn from "../resources/en/routeNames";
import routeNamesEs from "../resources/es/routeNames";

const Metatags = ({
  title,
  description,
  url,
  canonical,
  jsonld,
  language,
  error,
}) => {
  let routeName = canonical && language ? canonical.split("/")[1] : null;
  let translatedRoute =
    canonical && language
      ? {
          br: routeNamesBr[routeName],
          es: routeNamesEs[routeName],
          en: routeNamesEn[routeName],
        }
      : null;

  return (
    <Helmet>
      {/* HTML Tag */}
      <html
        lang={
          language
            ? langsObj[language]
            : langsObj[process.env.REACT_APP_DEFAULT_LANGUAGE]
        }
        data-lang={language ? language : process.env.REACT_APP_DEFAULT_LANGUAGE}
      />

      {/* json + ld - páginas de vaga utilizam o json+ld fornecido pelo one*/}
      <script type="application/ld+json">
        {jsonld ? jsonld : JSON.stringify(jsonld, null, 4)}
      </script>

      {/* <!-- Primary Meta Tags --> */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* <!-- PreRender --> */}
      {error ? <meta name="prerender-status-code" content="404" /> : null}

      {/* <!-- Open Graph / Facebook --> */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={`${process.env.REACT_APP_ENV_URL}/images/brand/og-image-wide.png`}
      />
      <meta
        property="og:image:url"
        content={`${process.env.REACT_APP_ENV_URL}/images/brand/og-image-wide.png`}
      />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta
        property="og:image"
        content={`${process.env.REACT_APP_ENV_URL}/images/brand/og-image-square.png`}
      />
      <meta
        property="og:image:url"
        content={`${process.env.REACT_APP_ENV_URL}/images/brand/og-image-square.png`}
      />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="630" />
      <meta property="og:image:height" content="630" />

      {/* <!-- Twitter --> */}
      <meta property="twitter:card" content="summary_large_image" />
      {/* <meta property="twitter:site" content="@levty"/> */}
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta
        property="twitter:image"
        content={`${process.env.REACT_APP_ENV_URL}/images/brand/og-image-wide.png`}
      />

      {/* Cononical URL */}
      <link
        rel="canonical"
        href={`${process.env.REACT_APP_ENV_URL}${
          language ? "/" + language : ""
        }${canonical + "/"}`}
      />

      {/* Different languages URL. Only if language enabled at the page */}
      {language &&
        Object.keys(langsObj).map((lang) => {
          return (
            <link
              rel="alternate"
              hrefLang={langsObj[lang]}
              key={langsObj[lang]}
              href={`${process.env.REACT_APP_ENV_URL}/${lang}${
                translatedRoute ? "/" + translatedRoute[lang] : ""
              }/`}
            />
          );
        })}
    </Helmet>
  );
};

export default Metatags;
